import React from "react";
import { Modal } from "react-bootstrap";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import successAnim from "../assets/success-interaction.lottie";

const SuccessModal = ({
  show,
  onHide,
  title = "Awesome!",
  message = "Your account has been successfully created. Welcome to the LegalPlatform community!",
  buttonText = "Explore Dashboard",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="success-modal"
      contentClassName="rounded-5 border-0 shadow-lg overflow-hidden"
      backdrop="static"
    >
      <Modal.Body className="text-center p-5 position-relative">
        <div className="mb-2" style={{ width: "200px", height: "200px", margin: "0 auto" }}>
          <DotLottieReact
            src={successAnim}
            autoplay
          />
        </div>
        <h2 className="mt-0 fw-bold" style={{ color: "#1a1a1a", fontSize: "2.2rem" }}>{title}</h2>
        <p className="text-muted fs-5 mt-3 mb-4 px-3">
          {message}
        </p>
        <button
          onClick={onHide}
          className="btn btn-dark btn-lg rounded-pill px-5 w-100 py-3 fw-bold shadow-sm"
          style={{
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            backgroundColor: "#000",
            border: "none",
            letterSpacing: "0.5px"
          }}
          onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
          onMouseOut={(e) => e.target.style.transform = "translateY(0)"}
        >
          {buttonText}
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
